export const endPoints = {
  GET_REMAINING_HOUSES: '/v2/mobile/house/remaining'
};
